import currencies from "../../../../../constants/CurrencyTypes";
import { formatNumberOnLocale, getInkTranslation } from "../../../../../constants/AppMethod";
import { useTranslation } from "react-i18next";
import { getCountryCode } from "../../../../../utils/Internationalization/handleAppInternationalization";
import { getLocalSessionData } from "../../../../../utils/Authentication/handleUserSession";
import { LOCALSESSIONDATAKEYS } from "../../../../../constants/AppConstants";
import { ENVSettings } from "../../../../../constants/ENVSettings";
import { useSelector } from "react-redux";

const EasyBuySummaryDetails = ({ isApplyBPlusNewDeviceDiscount = false, easyBuySummaryData, setEasyBuySummaryData, }) => {

  const { t } = useTranslation();
  const currency = easyBuySummaryData?.length > 0 ? easyBuySummaryData[0].currency : null;
  const newDevicePromoCodeResponse = useSelector((state => state.BROTHERPLUS.getNewDevicePromoCode));
  const total = (easyBuySummaryData || []).reduce(
    (sum, item) => sum + (Number(item?.discountedPrice) || 0),
    0
  );
  const originalTotal = (easyBuySummaryData || []).reduce(
    (sum, item) => sum + (Number(item?.price) || 0),
    0
  );
  let savings = originalTotal - total;
  // fetch coupon to apply 25% discount for new Connect devices
  const newDeviceDiscountCoupon = newDevicePromoCodeResponse?.success
    ? newDevicePromoCodeResponse?.newDevicePromoCode?.promoCode
    : null

  const handleCheckout = () => {
    const deviceModel = getLocalSessionData(LOCALSESSIONDATAKEYS.DEVICE_MODEL)
    const countryCode = getCountryCode();
    const languageCode = getLocalSessionData(LOCALSESSIONDATAKEYS.ECOPROWEBSIGNUPLANGCODE)
    const serialnumber = getLocalSessionData(LOCALSESSIONDATAKEYS.SERIAL_NUMBER)
    const newDeviceDiscountCouponQueryParam = (isApplyBPlusNewDeviceDiscount && newDeviceDiscountCoupon)
      ? `&coupon=${newDeviceDiscountCoupon}`
      : ''
    const supplyItemCode = easyBuySummaryData?.map(item => {
      return `sku=${item.supplyItemCode}`
    })
      .join("&");

    const baseurl = ENVSettings.BROTHER_STORE_BASE_URL;

    const newTabUrl = `${baseurl}?model=${deviceModel}&country=${countryCode}&lang=${languageCode}&sn=${serialnumber}&${supplyItemCode}${newDeviceDiscountCouponQueryParam}`;
    window.open(newTabUrl, '_blank');
    setEasyBuySummaryData([]);
  }

  return (
    <div className="easybuy-summary-content">
      <div className="summary-items">
        {easyBuySummaryData.map((item, index) => (
          <div key={index} className="summary-item">
            <div className="summary-item-header">
              <div>
                <div className="item-name">{getInkTranslation(item.name)}</div>
                <div className="item-details"> {item.label} ({item.details} {t("EASY_BUY_SUMMARY.PAGES")}) </div>
              </div>
              <div className="item-price">
                {formatNumberOnLocale(item?.discountedPrice, currencies[item?.currency]?.code)}
              </div>
            </div>
            <button className="remove-btn" onClick={() =>
              setEasyBuySummaryData(prevData =>
                prevData.filter((_, i) => i !== index)
              )
            }>{t("EASY_BUY_SUMMARY.REMOVE_BUTTON")}</button>
          </div>
        ))}
      </div>
      <div>
        {
          isApplyBPlusNewDeviceDiscount ? (
            <div className="saving-box">
              {t("EASY_BUY_SUMMARY.NEW_DEVICE_DISCOUNT", { "discountAmount": `${formatNumberOnLocale(savings, currencies[currency]?.code)}` })}
            </div>
          ) : (
            <div className="saving-box">
              {t("EASY_BUY_SUMMARY.SAVING_BOX")} <strong>{formatNumberOnLocale(savings, currencies[currency]?.code)}</strong> {t("EASY_BUY_SUMMARY.FREE_DELIVERY")}
            </div>
          )
        }

        <div className="summary-row promotion">
          <span>{t("EASY_BUY_SUMMARY.PROMOTION_LABEL")}</span>
          <span>-{formatNumberOnLocale(savings, currencies[currency]?.code)}</span>
        </div>

        <div className="summary-row total">
          <span>{t("EASY_BUY_SUMMARY.TOTAL_LABEL")}</span>
          <span> {formatNumberOnLocale(total,currencies[currency]?.code)}</span>
        </div>

        <button className="add-to-basket-btn" onClick={() => handleCheckout()} disabled={easyBuySummaryData.length === 0 ? true : false}>{t("EASY_BUY_SUMMARY.ADD_TO_BASKET")}</button>
        <p className="checkout-note">{t("EASY_BUY_SUMMARY.CHECKOUT_NOTE")}</p>
      </div>
    </div>
  )
}

export default EasyBuySummaryDetails;